import { ProductType } from './types'
import {
  DWB_PROGRAM_TYPE,
  HIGH_SCHOOL_PROGRAM_TYPE,
  K5_PROGRAM_TYPE,
  MSP_PROGRAM_TYPE,
} from '../program/types'
import { ADMIN_NAV_TITLE, DASHBOARD_NAV_TITLE } from './navTitles'
import {
  createKitProduct,
  createOstProduct,
  createSelForAdultsProduct,
} from './factories'

// NOTE: for products onboarded to the new subnav system,
// please add a title field to their object if you want them to have a title in the global nav

// THIS IS THE OFFICIAL PRODUCTION TEACH
// TODO [LEARN-8585]: remove skuCode and productType mapping from learn
export const admin = {
  defaultPage: 'implementation-guide',
  name: 'Admin',
  themeName: 'platform',
  title: ADMIN_NAV_TITLE,
}

export const dashboard = {
  name: 'Dashboard',
  themeName: 'platform',
  title: DASHBOARD_NAV_TITLE,
}

export const district = {
  defaultPage: 'supports',
  name: 'District Supports',
  productName: 'district-supports',
  themeName: 'platform',
}

export const elementary = {
  alternateNames: ['grades-k-5', 'elementary'],
  contentGroupCode: K5_PROGRAM_TYPE,
  defaultPage: 'teach',
  entryPoint: '3DURyazBws2DBVtEjYUPUR',
  lmsKey: 'Elementary',
  lmsKeyV2: 'K5SelDigital',
  name: 'Elementary',
  productName: 'elementary',
  skuCode: ProductType.K5.skuCode,
  themeName: 'elementary',
  title: 'Elementary Digital Program',
}

export const familyMindYeti = {
  defaultPage: 'playlists-and-supports',
  name: 'Mind Yeti',
  themeName: 'mindyeti',
}

export const familyResources = {
  defaultPage: 'elementary',
  name: 'Family Resources',
  themeName: 'familyResources',
  title: 'K–8 Digital Program Resources',
}

export const familyResourcesHS = {
  defaultPage: 'high-school',
  name: 'Family Resources',
  themeName: 'familyResources',
  title: 'High School Resources',
}

export const middleSchool = {
  alternateNames: ['grades-6-8', 'middle-school'],
  contentGroupCode: MSP_PROGRAM_TYPE,
  defaultPage: 'teach',
  entryPoint: '6V4P1pYzF8TMGKzNcPNG9B',
  lmsKey: 'Classes',
  lmsKeyV2: 'MspDigital',
  lmsKeyV1Dot5: 'MiddleSchool',
  name: 'Middle School',
  productName: 'middle-school',
  skuCode: ProductType.MSP.skuCode,
  themeName: 'middleSchool',
  title: 'Middle School',
}

export const digitalWellBeing = {
  alternateNames: ['digital-well-being'],
  contentGroupCode: DWB_PROGRAM_TYPE,
  defaultPage: 'lessons',
  name: 'Digital Well-Being',
  productName: 'digital-well-being',
  skuCode: null,
  themeName: 'middleSchool',
  title: 'Digital Well-Being',
}

export const mindYeti = {
  defaultPage: 'mind-yeti',
  entryPoint: '54apwXMO0wRboRsiy1KIvh',
  name: 'Mind Yeti',
  productName: 'mind-yeti',
  skuCode: null,
  themeName: 'mindyeti',
}

export const reports = {
  name: 'Reports',
  themeName: 'platform',
}

export const selForAdults = createSelForAdultsProduct({
  entryPoint: '5c2NEfz76UcLUugDvS8AOo',
  name: 'SEL for Adults',
  productName: 'sel-for-adults',
})

export const selForAdultsFieldTest = createSelForAdultsProduct({
  entryPoint: 'd9i22xTOiLdwnILB0iUSn',
  name: 'SEL for Adults Field Test',
  productName: 'sel-for-adults-field-test',
})

export const highSchool = {
  alternateNames: ['grades-9-12', 'high-school'],
  contentGroupCode: HIGH_SCHOOL_PROGRAM_TYPE,
  defaultPage: 'pathways',
  entryPoint: '4jWxfsChj2S6ZgIyzA2ACF',
  name: 'High School',
  productName: 'high-school',
  skuCode: 'HSP',
  themeName: 'highschool',
  title: 'High School',
}

// TODO: All of these should be removed once Planet EXPRESS dynamically adds top level keys to redux

export const k5Kit = createKitProduct({
  alternateNames: ['Second Step Elementary'],
  defaultPage: 'training',
  entryPoint: '7wz0n0pOvPPvF7lidBqyJa',
  name: 'Elementary Classroom Kits',
  productName: 'k5kit',
  skuCode: ProductType.SSP.skuCode,
  themeName: 'k5kit',
})

export const bpuKit = createKitProduct({
  defaultPage: 'training',
  entryPoint: '2ttriSkjEXDpDBnaG246Mt',
  name: 'Bullying Prevention Unit',
  productName: 'bpu',
  skuCode: ProductType.BPU.skuCode,
  themeName: 'bpu',
})

export const cpuKit = createKitProduct({
  defaultPage: 'training',
  entryPoint: '3RkEFGHWSJE1bWzdZFyKwN',
  name: 'Child Protection Unit',
  productName: 'cpu',
  skuCode: ProductType.CPU.skuCode,
  themeName: 'cpu',
})

export const elKit = createKitProduct({
  entryPoint: '3jbBI2DbMy17Eh4eHF4dN7',
  name: 'Early Learning',
  productName: 'elkit',
  skuCode: ProductType.SSPEL.skuCode,
  themeName: 'elkit',
})

export const msKit = createKitProduct({
  alternateNames: ['Grades 6–8 Classroom Kits'],
  defaultPage: 'teach',
  entryPoint: '5xTGruXnEfVhnJW2ztEMaW',
  name: 'Middle School Kit',
  productName: 'mskit',
  skuCode: ProductType.MSP.skuCode,
  themeName: 'mskit',
})

export const outOfSchoolTime = createOstProduct({
  name: 'Out-of-School Time',
  themeName: 'ostKit',
})

export const outOfSchoolTimeK1 = createOstProduct({
  name: 'Out-of-School Time K1',
  themeName: 'ostKitK1',
})

export const outOfSchoolTime23 = createOstProduct({
  name: 'Out-of-School Time 23',
  themeName: 'ostKit23',
})

export const outOfSchoolTime45 = createOstProduct({
  name: 'Out-of-School Time 45',
  themeName: 'ostKit45',
})

// Maps camelCase route keys (e.g. "bpuKit") to product config objects for URL lookup.
export const routeProductMap = {
  admin,
  bpuKit,
  cpuKit,
  district,
  digitalWellBeing,
  elKit,
  elementary,
  familyMindYeti,
  familyResources,
  familyResourcesHS,
  // hack, point this entry at high school because we query it by url path:
  family: familyResourcesHS,
  k5Kit,
  middleSchool,
  mindYeti,
  msKit,
  outOfSchoolTime,
  outOfSchoolTimeK1,
  outOfSchoolTime23,
  outOfSchoolTime45,
  reports,
  selForAdults,
  selForAdultsFieldTest,
  highSchool,
}
